<ng-container *transloco="let convert;">
  <!--      Begin Modal Layout Containers-->
  @if (isLoading) {
    <ng-content *ngTemplateOutlet="initialLoadingTemplate"></ng-content>
  }
  @if (!isLoading && !!templateContent && templateContent.visibleTemplate === multiResultModalTemplateEnum.RESULTS_TEMPLATE) {
    <ng-content *ngTemplateOutlet="resultsTemplate"></ng-content>
  }
  @if (!isLoading && !!templateContent  && templateContent.visibleTemplate === multiResultModalTemplateEnum.ERROR_TEMPLATE) {
    <ng-content *ngTemplateOutlet="errorTemplate"></ng-content>
  }

  <!--   Initial Loading Template-->
  <ng-template #initialLoadingTemplate>
    <div
      class="modal--action-list"
      role="dialog"
      aria-modal="true"
      aria-labelledby="grounding-action-modal-title"
      [attr.aria-label]="modalTemplateLabels.modalName"
      [attr.data-track-region]="modalTemplateLabels.headline"
      >
      <header class="modal__header">
        <h1 class="modal__title" id="grounding-action-modal-title" tabindex="-1">
          {{ headerText }}
        </h1>
      </header>

      <div class="modal__content">
        <div class="spinner-container">
          <app-spinner></app-spinner>
        </div>
      </div>

      <div class="modal-close-container text-end">
        <button
          id="grounding-action-modal-close"
          class="modal__close action_list_modal_close"
          aria-label="Close modal"
          (click)="handleCloseModal()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </ng-template>
  <!--  End Initial Loading Template -->

  <!--Begin Result Summary Template-->
  <ng-template #resultsTemplate>
    <div
      class="modal--action-list"
      role="dialog"
      aria-modal="true"
      aria-labelledby="grounding-action-modal-title"
      [attr.aria-label]="modalTemplateLabels.modalName"
      [attr.data-track-region]="modalTemplateLabels.headline"
      >
      <header class="modal__header">
        <h1 class="modal__title" id="grounding-action-modal-title" tabindex="-1">
          {{headerText}}
        </h1>
      </header>

      <div class="modal__content">

        <div
          class="modal__body bodyMinHeight"
          [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.updateSelectedModal.ariaLabelUpdateSelected')">

          @if (isSuccessVins) {
            <div class="success-icon successVins summaryMessage summaryContainer">
              <div class="innerConatiner">
                <i class="allycon-success-fill text-success updateIcon" aria-hidden="true"></i>
              </div>
              <div class="innerConatiner">
                <span class="result_message">{{ successMessage }}</span>
                <strong>{{ successVins }}</strong>
              </div>
            </div>
          }

          @if (isFailureVins) {
            <div>
              @for (updateErrorDisplay of templateContent.updateErrorDisplays; track updateErrorDisplay) {
                <div class="error-icon" class="updateErrorDisplay">
                  <div class="summaryContainer">
                    <div class="innerConatiner">
                      <i class="allycon-error-fill text-danger updateIcon" aria-hidden="true"></i>
                    </div>
                    <div class="innerConatiner">
                      <span class="result_message">{{ updateErrorDisplay.vins.length }}</span>
                      @if (updateErrorDisplay.vins.length === 1) {
                        <span>{{failureLabelSingular}}</span>
                      }
                      @if (updateErrorDisplay.vins.length !== 1) {
                        <span>{{failureLabelPlural}}</span>
                      }
                      <span>{{ updateErrorDisplay.errorMessage}}</span>
                      <span>{{ templatePunctuation.colonWithSpace }}</span>
                      <strong>{{ updateErrorDisplay.stringifiedVins }}</strong>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>

        <div class="modal__actions">
          <button
            class="btn btn-primary me-md-2 mb-3 mb-md-0"
            [attr.aria-label]="modalTemplateLabels.close"
            (click)="handleCloseModal()">
            <span>{{modalTemplateLabels.close}}</span>
          </button>

          @if (isFailureVins) {
            <button
              class="btn btn-outline-primary ms-md-3"
              [attr.aria-label]="modalTemplateLabels.closeAndSelectFailed"
              (click)="selectFailedVehicles()">
              <span>{{modalTemplateLabels.closeAndSelectFailed}}</span>
            </button>
          }
        </div>
      </div>

      @if (isLoading) {
        <div class="spinner-container">
          <app-spinner></app-spinner>
        </div>
      }

      <div class="modal-close-container text-end">
        <button
          id="grounding-action-modal-close"
          class="modal__close action_list_modal_close"
          aria-label="Close modal"
          (click)="handleCloseModal()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </ng-template>
  <!--End Result Summary Template -->

  <!--Start Error Template-->
  <ng-template #errorTemplate>
    <div
      class="modal--action-list"
      role="dialog"
      aria-modal="true"
      aria-labelledby="grounding-action-modal-title"
      [attr.aria-label]="modalTemplateLabels.modalName"
      [attr.data-track-region]="modalTemplateLabels.headline"
      >

      <header class="modal__header">
        <h1 class="modal__title" id="grounding-action-modal-title" tabindex="-1">
          {{headerText}}
        </h1>
      </header>

      <div class="modal__content">
        <div class="summaryContainer">
          <span class="pt-1 pe-4"><app-error-icon [fill]="'#d42925'"></app-error-icon></span>
          {{ errorMessage }}
        </div>

        <div class="modal__actions">
          <button
            class="btn btn-primary me-md-2 mb-3 mb-md-0"
            [attr.aria-label]="modalTemplateLabels.close"
            (click)="handleCloseModal()">
            <span>{{modalTemplateLabels.close}}</span>
          </button>
        </div>
      </div>

      <div class="modal-close-container text-end">
        <button
          id="grounding-action-modal-close"
          class="modal__close action_list_modal_close"
          aria-label="Close modal"
          (click)="handleCloseModal()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </ng-template>
  <!--End Error Template-->
</ng-container>
